import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import { Button, Col, Collapse, Progress } from "reactstrap";
import { userProfileService } from "../../user/services/profile";
// import { Mixpanel } from "./MixPanel";
import SoldOutStrip from "../assets/svgs/SoldOutStrip";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import InfoPopup from "./InfoPopup";
// import ReactPixel from "react-facebook-pixel";

const ObOpportunityBase = memo(function ObOpportunityBase(props) {
  console.log("ObOpportunityBase props", props);
  const { isMobile, userEmail } = props;
  const [showMore, setShowMore] = useState(false);
  const [date, setDate] = useState("");
  const [showPopUpMaxCoupon, setShowPopUpMaxCoupon] = useState(false);
  const [showPopUpText, setShowPopupText] = useState(false);

  const barStyle = {
    borderRadius: "none",

  }

  useEffect(() => {
    // ReactPixel.init("1613991859107974");
    if (props.opportunity && props.opportunity.maturityDate) {
      let dateArray = moment(
        new Date(props.opportunity?.maturityDate).getTime()
      ).format("Do MMM'YY");
      setDate(dateArray);
    }
  }, [props]);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const redirectToProduct = (product, productType) => {
    { process.env.REACT_APP_RENDER_GA === "true" &&
      setAnalyticsEvent('biddeasy-dashboard', 'View_Details_Click');
    }
    if (productType === "bonds") {
      window.location.href = `${process.env.REACT_APP_URL_ENDPOINTS}/${productType}/${product}`;
    } else if (productType === "mld") {
      window.location.href = "/platform/#/biddeasy-asset/mld/" + product;
    } else {
      window.location.href = `/platform/#/biddeasy-asset/${productType}/${product}`;
    }
    /* if (props.userEmail) Mixpanel.track("cl_view_bond_details",
      {
        "Bond Name" : props.opportunity.productName,
        "Email id": userEmail ? userEmail : ""
      }
    ); */
    // facebook pixel integration
    // ReactPixel.track("CLICKED VIEW DETAILS");
  };

  const handleInfoMaxClick = () => {
    setShowPopUpMaxCoupon(!showPopUpMaxCoupon);
  };

  const toggleInfoPopupMax = () => {
    setShowPopUpMaxCoupon(!showPopUpMaxCoupon);
  };

  const toggleInfoPopup = () => {
    setShowPopupText(!showPopUpText);
  };

  const handleInfoClick = () => {
    setShowPopupText(!showPopUpText);
  };

  const getMldReturns = (min, max) => {
    if (min === 0) {
      return `Up to ${max}%`;
    } else if (min > 0) {
      return `${min}% - ${max}%`;
    }
  }

  return (
    <Col className="opp-base">
      <div className="card-header">
        <div className="card-sub d-flex align-items-center">
          <img loading="lazy" src={props.opportunity.logoUrl} alt="logo"/>
          <p>{props.opportunity.displayName}</p>
        </div>
        
        {(props?.opportunity?.saleTag && props?.opportunity?.saleTag.length > 0) ?
          <div className="card-head d-flex align-items-center">
            <SoldOutStrip />
            <p className="centered">{props.opportunity.saleTag}</p>
          </div>
          :null
        }
      </div>
      {
          <>
          <div className="custom-progress">
            <div className="bar" style={{ width: `${Number(props.opportunity.soldOutTxt)}%` }}>
            </div>
          </div>
          <p className="sold-out-text">{props.opportunity.soldOutTxt}% Sold out</p>
          </>
      }
      
      <div className="first-fold">
        <div className="d-flex wrap mr-auto">
          <span class="mdi mdi-checkbox-blank-circle small-circle"></span>
          <p className="mb-0">
            {props.opportunity.productType === "ipo"
              ? "NCD IPO"
              : props.opportunity.productType === "mld"
              ? "MLD"
              : props.opportunity.productType === "bonds" ?
              (props.opportunity.product === "naviptc0" || props.opportunity.product === "naviptc1") ? "PTC":
              "Bond"
              : ""}
          </p>
        </div>
        {(props?.opportunity?.productType === "mld" && props?.opportunity?.highlights[0]?.web.length) ? 
          <div className="flex justify-content-between align-items-center ribbon">
              <p>{props?.opportunity?.highlights[0]?.web}</p>
          </div>
        : null
        }
      </div>
      <div className="card-opp-body">
        {!showMore && (
          <p className="opp-desc">
            {props.opportunity.description.length > 130
              ? props.opportunity.description.substr(0, 130).padEnd(133, ".")
              : props.opportunity.description}
            {props.opportunity.description.length > 40 && (
              <span
                className="font-weight-medium text-secondary ml-2"
                onClick={toggleShowMore}
                // onMouseOver={toggleShowMore}
                style={{ cursor: "pointer" }}
              >
                ...Show More
              </span>
            )}
          </p>
        )}
        <Collapse isOpen={showMore} className="opp-desc mb-3">
          {props.opportunity.description}
          <span
            className="font-weight-medium text-secondary ml-2"
            onClick={toggleShowMore}
            style={{ cursor: "pointer" }}
            // onMouseOver={toggleShowMore}
          >
            ...Show Less
          </span>
        </Collapse>
        <div className="divider" />
        <div className="d-flex align-items-center justify-content-between">

        {props.opportunity.productType === "ipo" ? (
                  <>
                    <p className="opp-desc date-color font-weight-semi-bold mt-3">
                      Close Date: {moment(new Date(props.opportunity?.closeDate).getTime()).format("Do MMM'YY")}
                    </p>
                  </>
                ) : (
                  <p className="opp-desc date-color font-weight-semi-bold mt-3">
                    Maturity Date: {date ? date : "NA"}
                  </p>
                )}

        </div>
        <div className="d-flex justify-content-between">
          <div className="details">
            <div className="inner">
              <p>Min Investment Amount</p>
              <p>
                {props.opportunity && props.opportunity.minAmt
                  ? props.opportunity.minAmt.oroNumber(2, true)
                  : "NA"}
              </p>
            </div>
            <div className="inner">
              <p>
                {props.opportunity.productType === "mld" ? (
                  <>
                    Returns
                    <span
                      onClick={handleInfoMaxClick}
                      className="mdi mdi-information-outline ml-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "15px",
                        marginTop: "10px",
                      }}
                    />
                  </>
                ) : props.opportunity.productType === "ipo" ? (
                  <>Interest Payout</>
                ) : (
                  "Principal payout"
                )}
              </p>
              <p>
                {props.opportunity.productType === "mld"
                  ? getMldReturns(props.opportunity.minReturns, props.opportunity.maxReturns)
                  : props.opportunity.productType === "ipo"
                  ? props.opportunity.couponType
                  : props.opportunity && props.opportunity.principalRepayment
                  ? props.opportunity.principalRepayment
                  : "NA"}
              </p>
            </div>
          </div>
          {/* <div className="divider-hr" /> */}
          <div className="details">
            <div className="inner">
              <p>
                {props.opportunity.productType === "mld"
                  ? "Credit Rating"
                  : "YTM"}
              </p>
              <p>
                {props.opportunity.productType === "mld"
                  ? props.opportunity.rating
                  : props.opportunity && props.opportunity.xirr
                  ? props.opportunity.xirr + "% p.a."
                  : "NA"}
              </p>
            </div>
            <div className="inner">
              <p>
                {props.opportunity.productType === "mld" ? (
                  <>
                    Multiplier
                    <span
                      onClick={handleInfoClick}
                      className="mdi mdi-information-outline ml-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "15px",
                        marginTop: "10px",
                      }}
                    />
                  </>
                ) : props.opportunity.productType === "ipo" ? (
                  <>Principal Payout</>
                ) : (
                  "Interest payout"
                )}
              </p>
              <p>
                {props.opportunity.productType === "mld"
                  ? (props.opportunity?.ISIN === "INE321N07418" ? "Up to " : "") +
                    props.opportunity.multiplier +
                    "x of " +
                    (props.opportunity.product === "gmldm0" || props.opportunity.product === "gmld1" ? "Gold Futures MCX" : "Nifty 50 Index") +
                    " Returns"
                  : props.opportunity.productType === "ipo"
                  ? props.opportunity.principalRepayment
                  : props.opportunity?.couponType
                  ? props.opportunity.couponType
                  : "NA"}
              </p>
            </div>
          </div>
        </div>
        {/* {props.opportunity.category === "live"  && */}
        <div className="btn-container">
          <Button
            onClick={() =>
              redirectToProduct(
                props.opportunity.product,
                props.opportunity.productType
              )
            }
          >
            View Details
          </Button>
        </div>
        {/* } */}
      </div>
      <InfoPopup
        showPopUpText={showPopUpMaxCoupon}
        toggleInfoPopup={toggleInfoPopupMax}
        // 
        text={ (props?.opportunity?.minReturns > 0) 
          ? "The returns on the MLD cannot be below " + + props?.opportunity?.minReturns +  "% and exceed "+ props?.opportunity?.maxReturns +"% irrespective of" + (props?.opportunity?.product === "gmldm0" || props?.opportunity?.product === "gmld1" ? " Gold Futures MCX" : " Nifty 50 Index") + " Returns."
          : "The returns on the MLD cannot exceed " +
  props?.opportunity?.maxReturns +
  "% irrespective of " +
  (props?.opportunity?.product === "gmldm0" || props?.opportunity?.product === "gmld1" ? "Gold Futures MCX" : "Nifty 50 Index") +
  " returns."
        }
      />

      <InfoPopup
        showPopUpText={showPopUpText}
        toggleInfoPopup={toggleInfoPopup}
        text={
          "The returns on the Underlying Asset (in this case " +
          (props?.opportunity?.product === "gmldm0" || props?.opportunity?.product === "gmld1" ? "Gold Futures MCX" : "Nifty 50 Index") +
          ") will be multiplied by " +
          props?.opportunity?.multiplier +
          "x to arrive at the returns of the MLD."
        }      />
    </Col>
  );
});

export default ObOpportunityBase;